<div class="container-flui" *ngIf="showPage">
  <app-header [logoEleicao]="eleicaoService.logoEleicao"></app-header>

  <div class="container customHeight">
    <div class="p-col">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
</div>

<app-spinner></app-spinner>
